import {HttpClient$, POST} from '@raison/network-facade';
import {atomWithMutation} from 'jotai-tanstack-query';
import {TariffName} from '~/processes/tariff-management';
import {NonOkResponseError} from '../errors';

export const tariffUpgrade = atomWithMutation(get => {
    const http = get(HttpClient$);
    return {
        // if tariff change would happen immediately - we would want to
        // invalidate cache of user data, but since it's a long process - there's not reason to
        // define mutationKey
        // mutationKey: [keys.user],
        mutationFn: async function postTariffUpgradeRequest(tariff: TariffName): Promise<void> {
            const response = await http('/v1/tariff/upgrade', POST({plan: tariff}));
            if (response.ok) {
                return;
            } else {
                throw new NonOkResponseError(response.request, response);
            }
        },
    };
});
tariffUpgrade.debugLabel = 'tariffUpgrade';
